// @flow
import React from "react"
import { push } from "connected-react-router"
import { compose, withHandlers, type HOC } from "recompose"
import withQuery from "hoc/withQuery"
import withSubmit from "hoc/withSubmit"
import withConnect from "hoc/withConnect"
import withMutation from "hoc/withMutation"
import { WrapNoDesktop } from "componentsStyled/Layout/Wrap"
import { FixedBottom, FixedBottomSpacer } from "componentsStyled/Layout/FixedBottom"
import urls from "data/router/urls"
import { openModal } from "data/modals/actions"
import { logout } from "data/user/actions"
import { selectLoggedIn } from "data/user/selectors"
import { deleteAccountMutation } from "data/user/graphql/mutations"
import { reservationListQuery } from "data/reservations/graphql/queries"
import ConfirmModal from "modals/Confirm"
import Button from "components/Button"
import SettingContent from "pages/Account/Routes/SettingContent"
import Content from "./Content"
import NoDelete from "./NoDelete"

const DeleteAccount = ({ loading, handleDelete, data, push }) => {
  const hasCheckedOutReservations = data.checked_out
  return (
    <SettingContent title="Delete account">
      <WrapNoDesktop>
        {hasCheckedOutReservations ? <NoDelete /> : <Content />}
      </WrapNoDesktop>
      <FixedBottomSpacer />
      <FixedBottom>
        {hasCheckedOutReservations ? (
          <Button
            onClick={() => push(urls.reservations)}
            loading={loading}
            fullwidth
          >
            Go to my reservations
          </Button>
        ) : (
          <Button onClick={handleDelete} loading={loading} fullwidth>
            Delete
          </Button>
        )}
      </FixedBottom>
    </SettingContent>
  )
}

const mapStateToProps = state => ({
  loggedIn: selectLoggedIn(state),
})

const mapDispatchToProps = {
  logout,
  openModal,
  push,
}

const enhancer: HOC<*, {||}> = compose(
  withConnect(mapStateToProps, mapDispatchToProps),
  withMutation(deleteAccountMutation),
  withSubmit({
    successText: "Account successfully deleted!",
    errorText: "There was a problem deleting your account.",
    onSuccess: props => props.logout,
    submit: props => props.submitMutation,
  }),
  withHandlers({
    handleDelete: props => () => {
      props.openModal(ConfirmModal, {
        title: "Are you sure?",
        message: "This action is permanent and cannot be undone.",
        onConfirm: props.submit,
      })
    },
  }),
  withQuery(reservationListQuery, {
    noEmpty: true,
    config: {
      skip: props => !props.loggedIn || props.loading,
    },
  }),
)

export default enhancer(DeleteAccount)



// WEBPACK FOOTER //
// ./src/pages/Account/Routes/Subpages/DeleteAccount/index.js